/**
 * Paket sipariş ödeme yöntemi adı Türkçeleştirici.
 *
 * Backend (`QuickSaleWithInvoiceManager` ve diğer manager'lar) `PaymentMethod`
 * alanına farklı casing ve dilde ham değerler yazıyor:
 *   - `cash`, `CASH`            → Nakit
 *   - `pos`, `POS`              → POS (Kredi Kartı)
 *   - `pavopay`, `PAVOPAY`      → Kredi Kartı (POS)
 *   - `credit_card`, `credit`,
 *     `creditcard`, `card`,
 *     `CREDIT_CARD`             → Kredi Kartı
 *   - `online`, `ONLINE`        → Online Ödeme
 *   - `paytr`                   → Online Ödeme (PayTR)
 *   - `open_account`,
 *     `OPEN_ACCOUNT`            → Açık Hesap
 *   - `unpaid`, `UNPAID`        → Ödenmedi
 *   - `other`, `OTHER`          → Diğer
 *   - `MIXED`, `mixed`          → Karma Ödeme
 *
 * Bilinmeyen değerler aynen geri döndürülür (zaten kullanıcı tarafından
 * "Yemek Kartı" gibi serbest etiket girilmiş olabilir — onları bozmayalım).
 *
 * `undefined` / boş string → `undefined` (çağıran taraf fişe ödeme satırı
 * basmayabilir).
 */
const PAYMENT_METHOD_TR_MAP: Record<string, string> = {
  cash: 'Nakit',
  nakit: 'Nakit',
  pos: 'POS (Kredi Kartı)',
  pavopay: 'Kredi Kartı (POS)',
  credit_card: 'Kredi Kartı',
  creditcard: 'Kredi Kartı',
  credit: 'Kredi Kartı',
  card: 'Kredi Kartı',
  online: 'Online Ödeme',
  online_payment: 'Online Ödeme',
  paytr: 'Online Ödeme (PayTR)',
  open_account: 'Açık Hesap',
  openaccount: 'Açık Hesap',
  unpaid: 'Ödenmedi',
  other: 'Diğer',
  mixed: 'Karma Ödeme',
};

export function translatePackagePaymentMethod(method?: string | null): string | undefined {
  if (!method) return undefined;
  const trimmed = method.trim();
  if (!trimmed) return undefined;
  const key = trimmed.toLowerCase().replace(/[\s-]+/g, '_');
  return PAYMENT_METHOD_TR_MAP[key] || trimmed;
}
